import * as React from 'react'
import './styles.css'
import '../Overview/styles.css'
import Carousel from '../Overview/components/Carousel'
import TrademarkText from '../../ui/TrademarkText'

const WorkforceVisibility = () => {
  return (
    <section className='overview-section workforce-visibility-section'>
      <div className='box'>
        <div className='workforce-visibility-grid'>
          <div className='workforce-visibility-content'>
            <h2 className='workforce-visibility-title'>
              Turn Workforce Visibility Into Strategic Advantage
            </h2>
            <p className='workforce-visibility-copy'>
              Powered by <TrademarkText>Pod Atlas™</TrademarkText>, organizations can
              visualize where critical skills exist, where shortages are emerging,
              and how workforce supply aligns with demand across locations,
              business units, and regions.
            </p>
            <p className='workforce-visibility-copy'>
              This level of spatial workforce intelligence is especially valuable
              for large enterprises, government agencies, and mission-critical,
              multi-location workforces.
            </p>
          </div>

          <div className='workforce-visibility-graphic overview-tile-container box-relative-gradient padding-container-removal'>
            <Carousel />
          </div>
        </div>
      </div>
    </section>
  )
}

export default WorkforceVisibility
